import type { Negocio } from "../dominio/tipos";
import { NegocioCreate } from "./NegocioCreate";
import { NegocioList } from "./NegocioList";
import { RedirigirAVentana } from "./VentanaFicha";

/**
 * Recurso `negocios` para <Resource> (SPEC.md §1–§3, §7). La ficha se abre siempre en la
 * ventana (VentanaFicha, 02/10/2026); /negocios/:id y /negocios/:id/show la abren sobre Leads.
 */
export default {
  list: NegocioList,
  create: NegocioCreate,
  edit: RedirigirAVentana,
  show: RedirigirAVentana,
  recordRepresentation: (r: Negocio) => r.nombre,
};
